export default [
    { name: "+86", code: "86" },
];